import { apiPostFormData } from './client';

/**
 * Преобразует URI файла (например /images/uuid) в полный URL для загрузки через miniapp proxy.
 */
export function fileUriToSrc(uri: string): string {
  if (uri.startsWith('http')) return uri;
  const path = uri.startsWith('/') ? uri : `/${uri}`;
  return `${window.location.origin}/api/files${path}`;
}

export interface UploadResult {
  uri: string;
}

/**
 * Загружает файл в указанную секцию.
 * POST /api/files/{section} с FormData.
 */
export async function uploadFile(
  section: string,
  file: File,
): Promise<{ id: string; uri: string; filename: string; size: number }> {
  const formData = new FormData();
  formData.append('file', file);

  const result = await apiPostFormData<UploadResult>(
    `/api/files/${section}`,
    formData,
  );

  const id = result.uri.substring(result.uri.lastIndexOf('/') + 1);

  return {
    id,
    uri: result.uri,
    filename: file.name,
    size: file.size,
  };
}
